import React from "react";
import Chart from "react-apexcharts";
import { useOutletContext } from 'react-router-dom';
import { CHART_TITLE_STYLE, buildPieSeries, pieSliceLabel, pieLegendWithValue } from "../HelperFunction/helperFunction";

function PieChartop({ optimizeddatasetcontripercentage, range, type }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  // Preprocess the dataset to group by type and calculate percentage contributions
  const plotdata = optimizeddatasetcontripercentage.map((item) => ({
    name: item.type,
    data: item.percentage_contribution,
  }));

  const { percents, display } = buildPieSeries(plotdata.map((item) => item.data));
  const realPct = (opts) => percents[opts?.seriesIndex] ?? 0;

  const options = {
    labels: ["Core", "Incremental", "Media"],
    title: {
      text: `Contribution Percentage (${type})`,
      align: "left",
      margin: 10,
      style: CHART_TITLE_STYLE,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          minAngleToShowLabel: 0,
          offset: 0,
        },
        donut: {
          size: "30%",
        },
      },
    },
    colors: ["#17A2B8", "#FF8C00", "#0D7C66"],
    chart: {
      id: "Download-Pie chart",
      type: "pie",
      toolbar: {
        show: true,
      },
      background: 'transparent',
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
      y: {
        formatter: (_val, opts) => `${realPct(opts).toFixed(2)}%`,
      },
    },
    dataLabels: {
      enabled: true,
      textAnchor: 'middle',
      style: {
        fontSize: "13px",
        fontWeight: 700,
        colors: ["white"],
      },
      formatter: (_val, opts) => pieSliceLabel(realPct(opts), 2),
    },
    legend: {
      fontSize: "13px",
      fontWeight: 600,
      fontFamily: "Inter, system-ui, sans-serif",
      formatter: (name, opts) => pieLegendWithValue(name, realPct(opts), 2),
    },
  };

  return (
    <div>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <Chart
        className="my-auto rr-apex"
        align="center"
        type="donut"
        height={260}
        options={options}
        series={display}
      />
    </div>
  );
}

export default PieChartop;
